export const SET_CATEGORY = "SET_CATEGORIES";
export const SET_ERROR="SET_ERROR"
